import React, { Component } from "react";
//import {debounce} from "underscore";
import RTMConst from "../../constants/Rtmconstants";

class FmPlayer extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			songName: "-",
			songArtist: "-",
			songAlbum: "-",
			isOpenControls: false,
			volumeFM: JSON.parse(localStorage.getItem('userData')).sessionData.ondemandId ? (JSON.parse(localStorage.getItem('userData')).default.memberFeedFmVolumeD2c ? JSON.parse(localStorage.getItem('userData')).default.memberFeedFmVolumeD2c : 25) : (JSON.parse(localStorage.getItem('userData')).userType === 2 ? (JSON.parse(localStorage.getItem('userData')).default.memberFeedFmVolumeD2c ? JSON.parse(localStorage.getItem('userData')).default.memberFeedFmVolumeD2c : 25) : (JSON.parse(localStorage.getItem('userData')).default.instructorFeedFmVolumeD2c ? JSON.parse(localStorage.getItem('userData')).default.instructorFeedFmVolumeD2c : 25)),
			showHostVolume: JSON.parse(localStorage.getItem('userData')).userType === 2 && !JSON.parse(localStorage.getItem('userData')).sessionData.ondemandId ? true : false,
			hostVolume: JSON.parse(localStorage.getItem('userData')).default.memberHostVolumeD2c ? JSON.parse(localStorage.getItem('userData')).default.memberHostVolumeD2c : 50,
			sep: '~@$',
			currentUserData: JSON.parse(localStorage.getItem('userData')),
			isOnDemand: ( JSON.parse(localStorage.getItem('userData')).sessionData.ondemandId && JSON.parse(localStorage.getItem('userData')).sessionData.ondemandId > 0 ) ? true : false,
			isMutedFm: false,
			showMusicControls: false,
		}

		this.playerFunctions = window['playerFunctions'];
		this.previousFMObject = '';
		window['setSongName'] = this.setSongName;
		window['setSongArtist'] = this.setSongArtist;
		window['setSongAlbum'] = this.setSongAlbum;
		window['changeVolumeFm'] = this.changeVolumeFm;
		window['changeFmVolumeHost'] = this.changeFmVolumeHost;

		window['muteUnmute'] = this.muteUnmute;
		window['isMutedFm'] = this.state.isMutedFm;
		window['changeFmMuteStatus'] = this.changeFmMuteStatus;
		window['adjustFmVolume'] = this.adjustFmVolume;
		window['checkIsMuted'] = this.checkIsMuted;
		window['hideVolumeBarAtMember'] = this.hideVolumeBarAtMember;
	}
 
   componentDidMount () {
   	   window.updateFmMessage = this.updateFmMessage;
   }
 
	openCloseControls=()=>{
		var isOpenControlsVar = this.state.isOpenControls;
		isOpenControlsVar = !isOpenControlsVar;
		this.setState({isOpenControls: isOpenControlsVar});
	}
	
	preventDef=(e)=>{
		e.preventDefault();
		e.stopPropagation();
	}
	
	changeVolumeFm=(e, mod)=>{
		if (mod == undefined)
			{
				this.setState({[e.target.id]: e.target.value}, 
				()=>{
					if ( this.state.isMutedFm  == false && !window['instructorMutedFm'] )
						{
							this.updateFmMessage();
						}
					
				});
				if ( this.state.isMutedFm  == false && !window['instructorMutedFm'] )
					{
						this.playerFunctions.changeVolume(e.target.value);
					}
				
			}
		else 
			{
				this.setState({volumeFM: mod});
				
				if ( this.state.isMutedFm  == false && !window['instructorMutedFm'] )
					{
						this.playerFunctions.changeVolume(mod);
					}
				
				
			}	
	}

	changeFmMuteStatus = (status) => {
		this.setState({isMutedFm: status});
        this.updateMuteStatus_notifyChannel(status);
	}
	
	changeVolumeHost=(e)=>{
		this.setState({[e.target.id]: e.target.value});
		window['reduceHostVolume'](parseInt(e.target.value));
	}
	
	setSongName=(par)=>{
		this.setState({songName: par}, ()=>{
			this.updateFmMessage();
			window['songName'] = this.state.songName;
		});
	}
	
	setSongArtist=(par)=>{
		this.setState({songArtist: par}, ()=>{
			this.updateFmMessage();
		});
	}

	setSongAlbum = (par) => {
		this.setState({songAlbum: par}, () => {
			this.updateFmMessage();
		});

	}
	
	updateFmMessage=()=>{
		if ( !this.state.showHostVolume )
			{	
				let mainUpdateObject = {};
				mainUpdateObject['volume'] = parseFloat(this.state.volumeFM);
				mainUpdateObject['song'] = this.state.songName;
				mainUpdateObject['artist'] = this.state.songArtist;
				mainUpdateObject['album'] = this.state.songAlbum;
				mainUpdateObject['isMuted'] = this.state.isMutedFm;
						
				mainUpdateObject = JSON.stringify(mainUpdateObject);
				let msg = 'feedFm'+this.state.sep+mainUpdateObject;
				
				if ( window['globalRTM'] && this.previousFMObject != mainUpdateObject )
					{
						let email = this.state.currentUserData.email;
						window['globalRTM']('RM-'+email, msg);
						
						this.previousFMObject = mainUpdateObject;
					}
			}
	}
	/*sendDebounced_REMOTE_VOLUME_CHANGE_FOR_MUSIC = debounce((volume) => {
		window['globalRTM'](`RM-${this.state.currentUserData.email}`, `${RTMConst.REMOTE_VOLUME_CHANGE_FOR_MUSIC}${this.state.sep}${volume}`);
	}, 1000);*/
	
	changeFmVolumeHost = (mod) =>{
		//this.sendDebounced_REMOTE_VOLUME_CHANGE_FOR_MUSIC(parseInt(mod));
		this.setState({volumeFM: mod});
		this.updateFmMessage();
		this.playerFunctions.changeVolume(mod);
	}
	
	muteUnmute=(mod)=>{
		this.setState({isMutedFm: mod}, ()=>{
			this.updateFmMessage();
		});
		this.updateMuteStatus_notifyChannel(mod);
		if ( window['addFeedFmToSessionData'] )
			{
				window['addFeedFmToSessionData'](mod);
			}
	}
	
	checkIsMuted=()=>{
		if ( this.state.isMutedFm )
			{
				this.muteUnmute(true);
			}
	}
	
	updateMuteStatus_notifyChannel(status) {
		window['isMutedFm'] = status;
		window['showHideVolume'](status);
		
		this.playerFunctions.setMuted(status);
		if ( status == false )
			{
				this.playerFunctions.changeVolume(this.state.volumeFM);
			}
		window['sendMessageToChannel']("feedFm" + this.state.sep + "mute" + this.state.sep + status);
	}
	
	adjustFmVolume = () =>{
		this.playerFunctions.changeVolume(this.state.volumeFM);
	}
	
	showHideVolume=()=>{
		
		if ( this.state.showMusicControls )
			{
				this.setState({
					showMusicControls: false,
				});
			}
		else 
			{
				this.setState({
					showMusicControls: true,
				});
			}			
	}
	
	hideVolumeBarAtMember=()=>{
		this.setState({
			showMusicControls: false,
		});
	}
	
	render() {
		return (
			<div className="feed_holder">
				{ this.state.isOnDemand &&
					<div className="feed_fm_control" onClick={this.openCloseControls}>
						{ this.state.isOpenControls &&
							<div className="feed_controls_content" onClick={this.preventDef}>
								{ this.state.showHostVolume &&
									<div className="one_feed_control instructor_feed_control">
										<div className="feed_control_title">Instructor</div>
										<div className="range_feed_content">
											<div className="relative_range">
												<input type="range" className="range_fm" id="hostVolume" value={this.state.hostVolume} name="volume "min="0" max="100" onChange={this.changeVolumeHost} />
											</div>
											<div className="fm_music_icon"></div>
										</div>
									</div>
								}
								<div className="one_feed_control">
									<div className="feed_control_title">Volume</div>
									<div className="range_feed_content">
										<div className="relative_range">
											<input type="range" className="range_fm" id="volumeFM" value={this.state.volumeFM} name="volume "min="0" max="100" onChange={this.changeVolumeFm} />
										</div>
										<div className="fm_music_icon"></div>
									</div>
								</div>
							</div>
						}
					</div>
				}
				<div className="feed_fm_info" >
					<div className="info_feed_content">
						<div className="one_fm_info">
							<div className="fm_icon song_icon"></div>
							<div className="fm_song">{this.state.songName}</div>
						</div>
						<div className="one_fm_info">
							<div className="fm_icon artist_icon"></div>
							<div className="fm_subinfo">{this.state.songArtist}</div>
						</div>
						<div className="one_fm_info">
							<div className="fm_icon album_icon"></div>
							<div className="fm_subinfo">{this.state.songAlbum}</div>
						</div>
					</div>
					{ !this.state.isOnDemand && this.state.showMusicControls &&
						<div className="controlsHolderPart" >
							<div className="holderBackground_color">
								<div className="feed_controls_content" onClick={this.preventDef}>
									<div className="one_feed_control">
										{this.state.showHostVolume ?
											<div className="feed_control_title">Volume</div>
											:
											<div className="feed_control_title">My Volume</div>
										}
										<div className="range_feed_content">
											<div className="relative_range">
												<input type="range" className="range_fm" id="volumeFM" value={this.state.volumeFM} name="volume "min="0" max="100" onChange={this.changeVolumeFm} />
											</div>
											{/*this.state.showHostVolume && 
												<div className="fm_music_icon"></div>
											*/}
										</div>
									</div>
									{!this.state.showHostVolume && !this.state.isOnDemand &&
									<div className="one_feed_control">
										<div className="feed_control_title">Mute Member's Music</div>
										<div className="relative_range newIconPlace">
											<div className="mute_feed" onClick={() => this.muteUnmute(this.state.isMutedFm ? false : true)}>
												{ this.state.isMutedFm &&
													<div className="muted_audio"></div>
												}
											</div>	
										</div>
									</div>
									}
								</div>
							</div>
						</div>
					}
					<div className="feedfm_logo">
						<div className="feed_info">
							<div className="feed_info_text feed_title">Feed.FM Disclaimer:</div>
							<div className="feed_info_text">There is no affiliation, connection, association or endorsement of the products, goods or services displayed on the Service by the copyright owners, featured recording artist and authors of the sound recordings (and the - musical works emboided therein) transmitted through the Feed.fm player.</div>
						</div>
					</div>
					{ !this.state.isOnDemand &&
						<div className="mute_feed" onClick={() => this.showHideVolume()}>
						</div>
					}
					
					
					
				</div>
			</div>
	)}
}
export default FmPlayer;
